'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z' });

var ZoomOutMap = function ZoomOutMap(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ZoomOutMap = (0, _pure2.default)(ZoomOutMap);
ZoomOutMap.muiName = 'SvgIcon';

exports.default = ZoomOutMap;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ZoomOutMap.js
// module id = 3028
// module chunks = 0